import { render } from "./PurchaseTab.vue?vue&type=template&id=2935b004"
import script from "./PurchaseTab.vue?vue&type=script&lang=js"
export * from "./PurchaseTab.vue?vue&type=script&lang=js"

import "./PurchaseTab.vue?vue&type=style&index=0&id=2935b004&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__